


























import { Component, Vue } from 'vue-property-decorator'
import CardProject from '../../components/core/project/CardProject.vue'
import { LETTER_STATES, Project } from '@/model/Project'
import router from '@/router'

@Component({
  components: { CardProject },
})
export default class ViewProjects extends Vue {
  get projects(): Project[] {
    return this.$store.getters.projects
  }

  get canCreateNewProject(): boolean {
    const mainProject = this.projects.find(p => p.main)
    return mainProject?.letterState === LETTER_STATES.COMPLETED
  }

  goToAddNewProject() {
    router.push('new-project')
  }
}
